import { TFAStatus } from 'multirpc-sdk';
import { createSelector } from 'reselect';

import { RootState } from 'store';

import {
  selectTFAStatus,
  selectTFAStatusState,
} from '../actions/fetchTFAStatus';

export const selectTFAState = (state: RootState) => state.tfa;

export const selectIsTFADialogOpened = createSelector(
  selectTFAState,
  state => state.isTFADialogOpened,
);

export const selectIsTFAEndpointRefetching = createSelector(
  selectTFAState,
  state => state.isTFAEndpointRefetching,
);

export const selectTFAError = createSelector(
  selectTFAState,
  state => state.tfaError,
);

export const selectTOTP = createSelector(selectTFAState, state => state.totp);

export const selectIsTFAStatusLoaded = createSelector(
  selectTFAStatusState,
  state => state.isSuccess,
);

export const selectIsTFAEnabled = createSelector(
  selectTFAStatus,
  status => status === TFAStatus.Enabled,
);
